<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="sell_your_device_dashboard_default text-center" style="min-height: 80vh">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width': '100%'}">
                    <div class="row">
                        <div class="col-md-4 col-xl-3 col-lg-3 col-sm-4">
                            <Sidebar></Sidebar>
                        </div>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 user-profile-form">
                                            <h5 style="font-size: 30px; font-weight: 700; margin-top: 30px;">
                                                Change Password
                                            </h5>
                                            <small>Please enter new password and re-type password</small>
                                            <br>
                                            <form class="form" role="form">
                                                <div class="form-group">
                                                    <input class="form-control" type="password" v-model="newPassword"  placeholder="Enter New Password"/>
                                                </div>
                                                <div class="form-group">
                                                    <input class="form-control" type="password" v-model="retypePassword"  placeholder="Enter Re-Type Password"/>
                                                </div>
                                                <div class="col-md-12 text-center">
                                                    <a href="javascript:void(0);" class="btn green" @click="changePassword()">Save Password</a>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style src="./css/common.css"></style>
<script>
import Loading from "vue-loading-overlay";
import Sidebar from "../layout/Sidebar.vue";
import {authHeader} from "../../auth";

export default {
    name: "ChangePassword",
    components: {
        Sidebar,
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            newPassword: '',
            retypePassword: ''
        }
    },
    created() {
        document.title = "Geek Buy Back - Change Password";
    },
    methods: {
        showMessage: function(typeMessage, title, detailMessage) {
            this.$swal.fire(
                title,
                detailMessage,
                typeMessage
            );
            return false;
        },
        checkFieldValidation: function(fieldName) {
            console.log(fieldName);
            if(typeof(fieldName) != 'undefined') {
                if(fieldName == null) {
                    return true;
                }
                else if(fieldName.length == 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        },
        changePassword: function() {
            this.isLoading = true;
            let errorFlag = false;
            let errorMessage = '';
            const formData = new FormData();
            formData.append('newPassword', this.newPassword);
            formData.append('retypePassword', this.retypePassword);

            if(this.checkFieldValidation(this.formData.newPassword) == true) {
                errorFlag = true;
                errorMessage += "Please enter new password";
            }
            else if(this.checkFieldValidation(this.formData.retypePassword) == true) {
                errorFlag = true;
                errorMessage += "Please enter retype password";
            }
            if(errorFlag ==  true) {
                this.isLoading = false;
                this.showMessage('error', 'Validation Failed', errorMessage);
                return false;
            }

            var config = {
                method: "POST",
                url: this.$api + this.$config.dashboard.changePasswordURL,
                data: this.formData,
                headers: authHeader()
            };
            this.$axios(config).then(response => {
                console.log(response.data);
                let row = response.data;
                this.isLoading = false;
                if(row.status == 0) {
                    this.showMessage('error', 'Unable to change password', row.message);
                    return false;
                }
                else if(row.status == 1) {
                    let successMessage = "Password Change Successfull";
                    this.showMessage('success', successMessage, row.message);        
                    this.formData.newPassword = "";           
                    this.formData.retypePassword = "";           
                    return false;
                }
            }).catch(e => {
                this.isLoading = false;
                console.log(e);
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
    }
}
</script>